/**
 * Primitive color scales — generated from DTCG tokens.
 *
 * Source of truth: internal/tokens/theme/generated/color/primitive.json
 * To update: modify Figma tokens → run `nx run tokens:sync-build`
 *
 * @see {@link @mds/tokens}
 */

import { colorPrimitive } from '@mds/tokens';

export type ColorRange = Record<10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90, string>;

type ColorChannelRange = Record<keyof ColorRange, string>;
type PrimitiveColorTokens = typeof colorPrimitive & {
  darkBlueChannel?: ColorChannelRange;
};

const primitiveColorTokens = colorPrimitive as PrimitiveColorTokens;

const toColorChannel = (hex: string) => {
  const value = hex.replace('#', '');

  return [
    Number.parseInt(value.slice(0, 2), 16),
    Number.parseInt(value.slice(2, 4), 16),
    Number.parseInt(value.slice(4, 6), 16),
  ].join(' ');
};

const toColorChannelRange = (range: ColorRange): ColorChannelRange =>
  Object.fromEntries(Object.entries(range).map(([key, value]) => [key, toColorChannel(value)])) as ColorChannelRange;

export const purple: ColorRange = colorPrimitive.purple as ColorRange;
export const darkBlue: ColorRange = colorPrimitive.darkBlue as ColorRange;
export const darkBlueChannel = primitiveColorTokens.darkBlueChannel ?? toColorChannelRange(darkBlue);
export const red: ColorRange = colorPrimitive.red as ColorRange;
export const orange: ColorRange = colorPrimitive.orange as ColorRange;
export const pink: ColorRange = colorPrimitive.pink as ColorRange;
export const green: ColorRange = colorPrimitive.green as ColorRange;
export const blue: ColorRange = colorPrimitive.blue as ColorRange;
export const grey: ColorRange = colorPrimitive.grey as ColorRange;
export const black = colorPrimitive.black;
export const white = colorPrimitive.white;
export const colors = {
  purple,
  darkBlue,
  darkBlueChannel,
  red,
  orange,
  pink,
  green,
  blue,
  grey,
  black,
  white,
  transparent: colorPrimitive.transparent,
};
